import { XAP, XBP, XCP } from './models_6s.js';
import ee from '../../services/earth-engine/index.js';

const get_nn = (dns, nodes, nxs) => {
  const nxsEE = ee.Number(nxs); //7
  const nodesEE = ee.Number(nodes); //11
  // const dns = ee.List(nn_image.reduceRegion(ee.Reducer.toList(), nn_image.geometry()).get('b1'));
  const start_nn = ee.Number(0);
  const ws_nn = nxsEE.multiply(nodesEE); //77
  const w0_nn = dns.slice(0, ws_nn); //0-77
  const bs_nn = nodesEE; //11
  const end_nn = start_nn.add(ws_nn).add(bs_nn); //88
  const b0 = dns.slice(start_nn.add(ws_nn), end_nn); //77-88  -B0

  const start_nn1 = end_nn; //88
  const ws_nn1 = nodesEE.multiply(nodesEE); //121
  const w1_nn1 = dns.slice(start_nn1, start_nn1.add(ws_nn1)); //88-209
  const bs_nn1 = nodesEE; //11
  const end_nn1 = start_nn1.add(ws_nn1).add(bs_nn1); //88 + 121 + 11 = 220
  const b1 = dns.slice(start_nn1.add(ws_nn1), end_nn1); //209 - 220  -B1

  const start_nn2 = end_nn1; //220
  const ws_nn2 = nodesEE.multiply(nodesEE); //121
  const w2_nn2 = dns.slice(start_nn2, start_nn2.add(ws_nn2)); //220-341
  const bs_nn2 = nodesEE; //11
  const end_nn2 = start_nn2.add(ws_nn2).add(bs_nn2); //220 + 121 + 11 = 352
  const b2 = dns.slice(start_nn2.add(ws_nn2), end_nn2); //341-352  -B2

  const start_nn3 = end_nn2; //352
  const ws_nn3 = nodesEE.multiply(nodesEE); //121
  const w3_nn3 = dns.slice(start_nn3, start_nn3.add(ws_nn3)); //352-473
  const bs_nn3 = nodesEE; //11
  const end_nn3 = start_nn3.add(ws_nn3).add(bs_nn3); //352 + 121 + 11 = 484
  const b3 = dns.slice(start_nn3.add(ws_nn3), end_nn3); //473-484  -B3

  const accum = (item, list) => {
    // ex: 0   // separa  w0_nn [0 a 77] em subgrupos de 11
    const start = ee.Number(item).multiply(nodesEE); //0 * 11 = 0
    const end = ee.Number(item).add(1).multiply(nodesEE); // 1 * 11 = 11
    return ee.List(list).add(w0_nn.slice(start, end)); // [].add( ind - 0,11 da lista de 0 a 77)
  };
  const arr = ee.List([]);
  const w0 = ee.List.sequence(0, nxsEE.subtract(1), 1).iterate(accum, arr); // List(0 - 6 , step 1 )

  const accum1 = (item, list) => {
    // separa  w1_nn1 [88-209] em subgrupos de 11
    const start = ee.Number(item).multiply(nodesEE);
    const end = ee.Number(item).add(1).multiply(nodesEE);
    return ee.List(list).add(w1_nn1.slice(start, end));
  };
  const arr1 = ee.List([]);
  const w1 = ee.List.sequence(0, nodesEE.subtract(1), 1).iterate(accum1, arr1);

  const accum2 = (item, list) => {
    // separa  w2_nn2 [220-341] em subgrupos de 11
    const start = ee.Number(item).multiply(nodesEE);
    const end = ee.Number(item).add(1).multiply(nodesEE);
    return ee.List(list).add(w2_nn2.slice(start, end));
  };
  const arr2 = ee.List([]);
  const w2 = ee.List.sequence(0, nodesEE.subtract(1), 1).iterate(accum2, arr2);

  const accum3 = (item, list) => {
    // separa  w3_nn3 [352-473] em subgrupos de 11
    const start = ee.Number(item).multiply(nodesEE);
    const end = ee.Number(item).add(1).multiply(nodesEE);
    return ee.List(list).add(w3_nn3.slice(start, end));
  };
  const arr3 = ee.List([]);
  const w3 = ee.List.sequence(0, nodesEE.subtract(1), 1).iterate(accum3, arr3);

  return [w0, b0, w1, b1, w2, b2, w3, b3]; // os bs são os ultimos 11 de cada lista e os ws são listas de 77 elem (w0) ou 121 (w1, w2, w3) divididas em subgrupos de 11
};

const nn = (image, nn_image, nodes, nx) => {
  const ret = ee.List(get_nn(nn_image, nodes, nx)); //separa a ee.List em subgrupos de 11 elementos
  const arrayImage1D = image.toArray();
  const arrayImage2D = arrayImage1D.toArray(1);
  const makeArrayImg = (index) => ee.Image.constant(ee.Array(ret.get(index)));
  const makeArrayTranspose = (index) => ee.Image.constant(ret.get(index)).toArray(1).arrayTranspose();
  const w0 = makeArrayImg(0);
  const w1 = makeArrayImg(2);
  const w2 = makeArrayImg(4);
  const w3 = makeArrayImg(6);
  const b0 = makeArrayTranspose(1);
  const b1 = makeArrayTranspose(3);
  const b2 = makeArrayTranspose(5);
  const b3 = makeArrayTranspose(7);
  const h1 = arrayImage2D.arrayTranspose().matrixMultiply(w0).add(b0);
  const in1 = h1.max(0);
  const h2 = in1.matrixMultiply(w1).add(b1);
  const in2 = h2.max(0);
  const h3 = in2.matrixMultiply(w2).add(b2);
  const in3 = h3.max(0);
  const h4 = in3.matrixMultiply(w3).add(b3);
  const out = arrayImage2D
    .arrayProject([1])
    .arrayFlatten([['B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B8A', 'B11', 'B12']]);
  return out;
};

export const get_xap = function (image) {
  const eeXAP = ee.List(XAP);
  return nn(image, eeXAP, 11, 7); //XAP = matrix[44,11]
};
export const get_xbp = function (image) {
  const eeXBP = ee.List(XBP);
  return nn(image, eeXBP, 11, 7);
};
export const get_xcp = function (image) {
  const eeXCP = ee.List(XCP);
  return nn(image, eeXCP, 11, 7);
};
